import { useContext } from 'react';
import { NotificationContext } from '../../../components/contexts/notification_context';
import { BookData, BookingsTableBook, TypeBookAction } from '../dto';
import { BOOK_ACTION_SUCCESS_MESSAGE } from '../variables';

interface EmitBookActionParams {
  bookId?: string;
  bookToken?: string;
  action: TypeBookAction;
  data?: Object;
  onUpdate: (data: BookingsTableBook | BookData) => void;
  handleCloseModal: () => void;
  getFullBookData?: boolean;
}

export function useBookActions() {
  const notyContext = useContext(NotificationContext);

  function emitBookAction({
    bookId,
    bookToken,
    action,
    data = null,
    onUpdate,
    handleCloseModal,
    getFullBookData = false,
  }: EmitBookActionParams) {
    const requestOptions: RequestInit = {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const queryParams = new URLSearchParams({ get_full_data: getFullBookData.toString() });

    if (data) requestOptions.body = JSON.stringify(data);

    if (!bookId && !bookToken) return;

    const url = bookToken ? `/extranet_${action}_book/${bookToken}` : `/api/books/${bookId}/${action}?${queryParams}`;

    fetch(url, requestOptions)
      .then((res) => {
        if (res.ok) {
          notyContext.addNotification({
            type: 'success',
            title: 'Успешно!',
            message: BOOK_ACTION_SUCCESS_MESSAGE[action],
          });
          handleCloseModal();
          return res.json();
        } else {
          notyContext.addNotification({
            type: 'danger',
            title: 'Что-то пошло не так.',
            message: 'Обратитесь к разработчикам.',
          });
        }
      })
      .then((data: BookingsTableBook | BookData) => {
        if (data) onUpdate(data);
      })
      .catch((err) => {
        console.error(err);
        notyContext.addNotification({
          type: 'danger',
          title: 'Что-то пошло не так.',
          message: 'Обратитесь к разработчикам.',
        });
      });
  }

  return { emitBookAction };
}
